import weCodeIcon from "./assets/we_code.svg";
import updateIcon from "./assets/update.svg";
import permissionIcon from "./assets/permission.svg";
import lightAppIcon from "./assets/light_app.svg";
import robotIcon from "./assets/robot_icon.svg";
import { TO_BE_PUBLISH_STATUS, UNDER_REVIEW_STATUS } from "./constant";
import history from "@src/utils/history";
import { APP_TYPE } from '@src/utils/common'

export const versionAnswer = (vNew, vOld) => {
  let vn = ''
  if (vNew == '' || vNew == null || vNew === undefined) {
    return false;
  }
  else {
    vn = vNew?.replace(/(^\s+)|(\s+$)/gi, '');
  }
  let vo = vOld?.replace(/(^s+)|(\s+$)/gi, '')
  if (!vn || !vo) {
    return true;
  }
  let reg = /\d(\.|\d)*\d/gi;
  vn = vn.match(reg)?.[0];
  vo = vo.match(reg)?.[0];

  let vnArr = vn?.split('.')
  let voArr = vo?.split('.')
  if (vnArr[0] > voArr[0]) {
    return true
  }
  else if (vnArr[0] === voArr[0]) {
    if (vnArr[1] > voArr[1]) {
      return true
    }
    else if (vnArr[1] === voArr[1]) {
      if (vnArr[2] > voArr[2]) {
        return true;
      }
      else if (vnArr[2] == voArr[2]) {
        return false
      }
    }
  }
  return false
}

export const contentList = (versionUpdateInfo) => {
  let newList = [];
  const { appInfoIsUpdate, weAppIsUpdate, h5IsUpdate, scopeUpdate, robotIsUpdate } =
    versionUpdateInfo;
  if (appInfoIsUpdate) {
    newList.push({
      icon: updateIcon,
      title: "应用信息",
      desc: "已应用",
    });
  }
  if (weAppIsUpdate) {
    newList.push({
      icon: weCodeIcon,
      title: "We码",
      desc: "已启用",
    });
  }
  if (h5IsUpdate) {
    newList.push({
      icon: lightAppIcon,
      title: "轻应用",
      desc: "已启用",
    });
  }
  if (scopeUpdate) {
    newList.push({
      icon: permissionIcon,
      title: "权限",
      desc: "申请了新的接口权限",
    });
  }
  if (robotIsUpdate) {
    newList.push({
      icon: robotIcon,
      title: "机器人",
      desc: "已启用",
    });
  }
  return newList
};

export const clickVersionItem = (record, appId, paramsType) => {
  // 三方应用如果没有提交预审，跳转update和underReview
  // 三方应用如果提交预审，跳转view
  // preReviewStatus：0：未提交预审 1: 审核中; 2: 审核通过; 3: 审核被驳回
  const status = record.versionType === TO_BE_PUBLISH_STATUS ? 1 : 0;
  if(paramsType == APP_TYPE.isv ){
    if(record.preReviewStatus != 0){
      history.push(`/${paramsType}/appdetailV2/editionManage?id=${appId}&versionStatus=view`, {
        state: { versionName: record.versionName, status: status, preReviewStatus: record.preReviewStatus },
      });
      return
    }else{
      let url = `/${paramsType}/appdetailV2/editionManage?id=${appId}`;
      if (record.versionType === TO_BE_PUBLISH_STATUS) {
        url += "&versionStatus=update";
      } else if (record.versionType === UNDER_REVIEW_STATUS) {
        url += "&versionStatus=underReview";
      }
      history.push(url, {
        state: { versionName: record.versionName, status: status, preReviewStatus: record.preReviewStatus },
      });
      return
    }
  }
  let url = `/${paramsType}/appdetailV2/editionManage?id=${appId}`;
  if (record.versionType === TO_BE_PUBLISH_STATUS) {
    url += "&versionStatus=update";
  } else if (record.versionType === UNDER_REVIEW_STATUS) {
    url += "&versionStatus=underReview";
  } else {
    url += "&versionStatus=view";
  }
  history.push(url, {
    state: { versionName: record.versionName, status: status },
  });
};

export const isCreateVersion = (data) => {
  let isDisabled = !!data.filter(
    (item) =>
      item.versionType === TO_BE_PUBLISH_STATUS ||
      item.versionType === UNDER_REVIEW_STATUS
  ).length;
  return isDisabled
};


export const handleGetSelected = (value) => {
  let arr = [];
  Object.keys(value).forEach((v) => {
    let o = {
      chineseName: value[v].title ? value[v].title : "--",
      accountId: value[v].key,
      isLeaf: true,
      isUser: true,
    };
    arr.push(o);
  });
  return arr
  setAdminUserList(arr);
};
